import { WithPlanBadge } from '@/shared/components/Badge/PlanBadge';
import { useUserPlanManager } from '@/shared/plan';
import { useUpsellingGuard } from '@/shared/plan';
import { EditTools } from '../../EditTools';
import { useAiGenerateAnswerList } from './useAiGenerateAnswerList';
export const AiGenerateAnswerListButton = () => {
  const {
    userPlanManager
  } = useUserPlanManager();
  const {
    generate,
    disabled
  } = useAiGenerateAnswerList();
  const featurePlanType = userPlanManager.getFeaturePlanType('AI_ANSWER_GENERATION');
  const upsellingGuard = useUpsellingGuard();
  return <WithPlanBadge planType={featurePlanType} isBadgeVisible={true} data-sentry-element="WithPlanBadge" data-sentry-component="AiGenerateAnswerListButton" data-sentry-source-file="AiGenerateAnswerListButton.tsx">
      <EditTools.AiAnswerGenerationButton disabled={disabled} onClick={() => {
      void upsellingGuard(generate, {
        feature: 'AI_ANSWER_GENERATION',
        from: 'ai_subjective_answer_list'
      });
    }} data-sentry-element="unknown" data-sentry-source-file="AiGenerateAnswerListButton.tsx" />
    </WithPlanBadge>;
};